export const ATTEMPTS_LIMIT = 3;
